import type {VideoCropperPanelProps} from '@Panels/video-cropper-panel/video-cropper-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container/modal-container.types';

export interface VideoCropperModalProps extends VideoCropperPanelProps {
  onClose?(): void;
}

export const openVideoCropperModal = (props: VideoCropperModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.VIDEO_CROPPER_MODAL,
      panelProps: props,
    })
  );
};
